var _desc, _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlowStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.6 12.13C5.85 12.46 6 12.88 6 13.33C6 14.44 5.1 15.33 4 15.33C2.89 15.33 2 14.44 2 13.33C2 12.22 2.89 11.33 4 11.33C4.29 11.33 4.56 11.39 4.81 11.5L5.75 10.32C5.14 9.64 4.89 8.73 5.03 7.86L3.68 7.41C3.31 7.96 2.7 8.33 2 8.33C0.89 8.33 0 7.44 0 6.33C0 5.22 0.89 4.33 2 4.33C3.1 4.33 4 5.22 4 6.33C4 6.38 4 6.42 3.99 6.47L5.34 6.92C5.77 6.12 6.56 5.53 7.49 5.38L7.49 3.94C6.64 3.71 6 2.93 6 2C6 0.89 6.89 0 8 0C9.1 0 10 0.89 10 2C10 2.93 9.35 3.71 8.5 3.94L8.5 5.38C9.43 5.53 10.22 6.12 10.64 6.92L12 6.47C12 6.42 12 6.38 12 6.33C12 5.22 12.89 4.33 14 4.33C15.1 4.33 16 5.22 16 6.33C16 7.44 15.1 8.33 14 8.33C13.29 8.33 12.68 7.96 12.31 7.42L10.96 7.87C11.1 8.73 10.85 9.64 10.24 10.33L11.18 11.51C11.43 11.39 11.7 11.33 12 11.33C13.1 11.33 14 12.22 14 13.33C14 14.44 13.1 15.33 12 15.33C10.89 15.33 10 14.44 10 13.33C10 12.88 10.14 12.46 10.39 12.13L9.45 10.95C8.56 11.45 7.45 11.46 6.54 10.95L5.6 12.13Z",
    fill: "#5E5C71",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowStart);
export default __webpack_public_path__ + "static/media/flowStart.73f96f5fdc695d34c66cbc84f760b39b.svg";
export { ForwardRef as ReactComponent };